import bootbox from "bootbox";

function dialogEnvironment(environment_id, $btn)
{
  let environment_id_int = parseInt(environment_id);
  
  let functionParams =
  {
    environment_id: environment_id_int
  };

  let ajaxParams = 
  {
    sourceEl: $btn,
    effectTarget: $btn,
    onSuccess: function(response)
    {
      let $frm = $(response.content);

      bootbox.dialog(
      {
        title: environment_id_int > 0 ? App.Lang.get('edit_environment') : App.Lang.get('new_environment'),
        message: $frm,
        buttons:
        {
          cancel:
          {
            label: App.Lang.get('cancel'),
            className: 'btn-secondary'
          },
          ok:
          {
            label: App.Lang.get('save'),
            className: 'btn-primary',
            callback: function(event)
            {
              let $btnSave = $(event.target);

              if ($frm.valid())
              {
                let functionParams =
                {
                  environment_id: environment_id_int,
                  data: $frm.serialize()
                };

                let ajaxParams = 
                {
                  sourceEl: $btnSave,
                  effectTarget: $btnSave,
                  onSuccess: function()
                  {
                    window.location.reload();
                  }
                };

                App.Helper.ajaxCall("environment_save", functionParams, ajaxParams);
              }

              return false;
            }
          }
        },
      });
    }
  };

  App.Helper.ajaxCall("environment_form", functionParams, ajaxParams);
}

$(document).ready(function()
{
  if ($("#btnEnvironmentNew").length === 0) return;

  $("#btnEnvironmentNew").on("click", function()
  {
    let $btn = $(this);
    let environment_id = 0;

    dialogEnvironment(environment_id, $btn);
  });
  
  $(".btnEnvironmentEdit").on("click", function(event)
  {
    event.preventDefault();

    let $btn = $(this);
    let environment_id = $btn.parents(".elEnvironment").first().data("id");

    dialogEnvironment(environment_id, $btn);
  });

  $(".btnEnvironmentDelete").on("click", function(event)
  {
    event.preventDefault();
    let $btn = $(this);
    
    if (confirm(App.Lang.get("confirm_delete")))
    {
      let functionParams =
      {
        environment_id: $btn.parents(".elEnvironment").first().data("id")
      };

      let ajaxParams = 
      {
        sourceEl: $btn,
        effectTarget: $btn,
        onSuccess: function()
        {
          window.location.reload();
        }
      };

      App.Helper.ajaxCall("environment_delete", functionParams, ajaxParams);
    }
  });
  
  $(".btnEnvironmentLink").on("click", function(event)
  {
    event.preventDefault();

    let $btn = $(this);
    window.location.href = $btn.data("href");
  });
});
